// Types
import { ToolbarLevel } from './MobileToolbarConstants';
import { ToolbarListType } from '../../workspace/toolbar/toolbarTypes';

/**
 * Determines whether the toolbar is primary (large with tool names & more padding)
 * or secondary (smaller and more compact).
 */
export const getToolbarLevel: (toolListType: ToolbarListType) => ToolbarLevel = (toolListType) => {
    switch (toolListType) {
        case ToolbarListType.EDITING:
        case ToolbarListType.EDITING_RANGE:
            return ToolbarLevel.SECONDARY;
        default:
            return ToolbarLevel.PRIMARY;
    }
};
